import Vue from 'vue'
import Vuex from 'vuex'
import version from '@/version'
import axios from 'axios'
import articles from './Article/index'
import calendar from './Calendar/index'
import excuses from './Excuse/index'
import warnings from './Warning/index'
import cms from './CMS/index'
import helpers from './../helpers'
import quickAccesses from './Quickaccess/index'
import user from './User/index'
import invitation from './Invitation/index'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        version: 0,
        accessToken: '',
        permissions: {

        }
    },
    getters: {
        authenticated: state => {
            return state.accessToken !== ''
        },
        getStoredPermissions: state => {
            return state.permissions
        },
        getAuthToken: (state) => {
            return state.accessToken
        }
    },
    mutations: {
        initialiseStore(state) {
            if (localStorage.getItem('store')) {
                let store = JSON.parse(localStorage.getItem('store'))
                if (store.version === version.number) {
                    this.replaceState(
                        Object.assign(state, store)
                    )
                } else {
                    state.version = version.number
                }
            }
        },
        clearAccessToken(state) {
            state.accessToken = ''
        },
        setAccessToken(state, token) {
            state.accessToken = token
        },
        setPermissions(state, permissions) {
            state.permissions = permissions
        }
    },
    actions: {
        // eslint-disable-next-line no-unused-vars
        uploadFile({commit}, file) {
            let formData = new FormData();
            formData.append("file", file);
            return axios.post(process.env.VUE_APP_API_URL + '/file', formData)
                .then(response => {
                    helpers.handleSuccessMessage("Datei Erfolgreich hochgeladen.")
                    return response.data
                })
                .catch(exception => helpers.handleMildAxiosError(exception))
        },
        getPermissions({commit}) {
            axios.get(process.env.VUE_APP_API_URL + '/permissions')
                .then(response => {
                    commit('setPermissions', response.data.data)
                })
                .catch(exception => {
                    commit('clearAccessToken')
                    helpers.handleMildAxiosError(exception)
                })

        }
    },
    modules: {
        articles,
        calendar,
        excuses,
        warnings,
        cms,
        quickAccesses,
        user,
        invitation
    }
})
